<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb
        el-col.pt-5.text-right(:span="15")
          el-button(v-show="activeName == 'first'" type="primary" size="mini" @click="handleEdit") 标记已读
          el-button(type="primary" size="mini" @click="$router.go(-1)") 返回
      el-tabs.title(v-model="activeName" @tab-click="handleTabClick")
        el-tab-pane(:label="'未读消息('+count1+')'" name="first")
        el-tab-pane(:label="'已读消息('+count2+')'" name="second")
    div(style="height:110px")
    el-main.white.pa-3.ma-4
      el-table(:data="data" v-loading="loading" row-key="id" size="mini" @selection-change="handleSelectionChange" tooltip-effect="dark")
        el-table-column(v-if="activeName == 'first'" type="selection" width="55" key="selection")
        //- el-table-column(type="expand")
        //-   template(slot-scope="props")
        //-     div {{props.row.content}}
        el-table-column(prop="content" label="标题" key="content")
          //- template(slot-scope="scope")
          //-   div(style="width:200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;") {{scope.row.content}}
        el-table-column(prop="create_date" label="提醒时间" width="150" key="create_date")
      el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total,sizes, prev, pager, next, jumper" :total="count" background)
</template>
<script>
export default {
  data() {
    return {
      h: "",
      loading: false,
      activeName: "first",
      data: [],
      count: 0,
      count1: 0,
      count2: 0,
      list: {
        page_num: 1,
        page_size: 10,
        is_read: 0,
      },
      list1: {
        page_num: 1,
        page_size: 10,
        is_read: 0,
      },
      list2: {
        page_num: 1,
        page_size: 10,
        is_read: 1,
      },
      multipleSelection: [],
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleTabClick(tab) {
      let data = this.list;
      if (tab.name == "first") {
        data.page_size = this.list1.page_size;
        data.page_num = this.list1.page_num;
        data.is_read = this.list1.is_read;
      } else if (tab.name == "second") {
        data.page_size = this.list2.page_size;
        data.page_num = this.list2.page_num;
        data.is_read = this.list2.is_read;
      }
      this.$router.push({
        path: this.$route.path,
        hash: "#" + tab.name,
        query: data,
      });
    },
    async getList() {
      this.loading = true;
      let res = await this.$api.message.getList(this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count1 = res.count1 ? res.count1 : 0;
        this.count2 = res.count2 ? res.count2 : 0;
        if (this.count1) {
          this.$store.commit("SET_BADGE", false);
          this.$store.commit("SET_MESSAGE_NUM", this.count1);
        } else {
          this.$store.commit("SET_BADGE", true);
        }
        switch (this.activeName) {
          case "first":
            this.count = this.count1;
            break;
          case "second":
            this.count = this.count2;
            break;
          default:
            break;
        }
      }
    },
    async handleEdit() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择需要操作的数据",
          type: "error",
        });
        return false;
      }
      let data = [];
      for (var i in this.multipleSelection) {
        data.push(this.multipleSelection[i].id);
      }
      this.loading = true;
      let res = await this.$api.message.edit(data.toString());
      this.loading = false;
      if (res) {
        this.getList();
      }
    },
    initList() {
      let data = this.$route.query;
      if (JSON.stringify(data) != "{}") {
        this.list = this.$utils.cloneDeep(data);
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
              ? parseInt(data.page_size)
              : this.page_sizes[0];
        }
      } else {
        this.list.is_read = this.list1.is_read;
      }
      switch (this.activeName) {
        case "first":
          this.list1.page_size = this.list.page_size;
          this.list1.page_num = this.list.page_num;
          break;
        case "second":
          this.list2.page_size = this.list.page_size;
          this.list2.page_num = this.list.page_num;
          break;
        default:
          break;
      }
    },
    init() {
      this.activeName = this.$route.hash
        ? this.$route.hash.split("#")[1]
        : "first";
      this.initList();
      this.getList();
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>
